import { defineStyleConfig } from '@chakra-ui/react';

export const Button = defineStyleConfig({
  baseStyle: {
    fontWeight: 600,
    fontFamily: 'body',
    borderRadius: 'lg',
    transition: 'all 250ms cubic-bezier(0.16, 1, 0.3, 1)',
    _active: { transform: 'scale(0.97)' },
    _focusVisible: {
      boxShadow: 'focus',
      outline: 'none',
    },
  },
  defaultProps: {
    colorScheme: 'sage',
  },
  variants: {
    /** Primary CTA — Start Cooking, Generate, Save */
    'kitchen-primary': {
      bg: 'sage.500',
      color: 'white',
      h: '56px',
      fontSize: 'lg',
      fontWeight: 700,
      _hover: {
        bg: 'sage.600',
        boxShadow: 'glow-sage',
        transform: 'translateY(-1px)',
      },
      _active: { bg: 'sage.700', transform: 'scale(0.97)' },
    },
    /** Secondary action — Generate, mode toggles */
    'kitchen-secondary': {
      bg: 'terracotta.400',
      color: 'white',
      fontWeight: 700,
      _hover: {
        bg: 'terracotta.500',
        boxShadow: 'glow-terracotta',
        transform: 'translateY(-1px)',
      },
      _active: { bg: 'terracotta.600', transform: 'scale(0.97)' },
    },
    /** Subtle outline — secondary actions in modals/footers */
    'kitchen-outline': {
      borderWidth: '1.5px',
      borderColor: 'border.subtle',
      bg: 'transparent',
      color: 'text.primary',
      _hover: {
        bg: 'surface.hover',
        borderColor: 'sage.300',
      },
      _active: { bg: 'surface.active' },
    },
  },
});
